import { Skill, ReviewerSkill } from '../models/User';

export type SkillsMap = { [key: number]: Skill };

export const modifySkillsMap = (
  skillsMap: SkillsMap,
  skillId: number,
  property: string,
  value: number | string
) => {
  return {
    ...skillsMap,
    [skillId]: {
      ...skillsMap[skillId],
      [property]: value,
    },
  };
};

export const verifySkillsMap = (skillsMap: SkillsMap) => {
  return Object.values(skillsMap).every(
    (item) =>
      item.years_experience !== null && item.skill_level && item.name && item.id
  );
};

export const removeSkillFromMap = (
  skillsMap: SkillsMap,
  skillToRemove: number
) => {
  const newSkillsMap = { ...skillsMap };
  delete newSkillsMap[skillToRemove];
  return newSkillsMap;
};

export const prepareSkillsMapForStorage = (skillsMap: {
  [key: number]: Skill;
}) => {
  const skillsToSubmit: { [key: number]: ReviewerSkill } = {};
  Object.values(skillsMap).forEach((item) => {
    skillsToSubmit[item.id] = {
      skill_level: item.skill_level,
      years_experience: item.years_experience,
    };
  });

  return skillsToSubmit;
};
